import script from "./AccountUserView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountUserView.vue?vue&type=script&setup=true&lang=ts"

import "./AccountUserView.vue?vue&type=style&index=0&id=4adfa856&lang=css"

const __exports__ = script;

export default __exports__